import { Chip, Table, TableColumns } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';

type NotImportableLessonsTableType = {
  name: string;
  reason: string;
  connected: boolean;
};

type NotImportableLessonsTableProps = {
  data: NotImportableLessonsTableType[];
};

export const NotImportableLessonsTable = ({ data }: NotImportableLessonsTableProps) => {
  const { t } = useTranslation();

  const columns: TableColumns<NotImportableLessonsTableType>[] = [
    { id: 'name', accessorKey: 'name', header: t('planungImport.lessonInPlanung'), size: 300, canExpand: true },
    {
      id: 'reason',
      accessorKey: 'reason',
      header: t('planungImport.notImportableReason'),
      size: 300,
      canExpand: true,
    },
    {
      id: 'connected',
      accessorKey: 'connected',
      header: t('planungImport.connected'),
      size: 72,
      cell: () => <Chip isSmall value={<>&#10007;</>} color={'var(--color-white)'} bgColor='var(--color-error)' />,
    },
  ];

  return (
    <Table<NotImportableLessonsTableType>
      columns={columns}
      data={data}
      hideHeader={data.length === 0}
      emptyStateSettings={{
        forcedHeight: '15vh',
        title: '',
        subtitle: '',
      }}
      lastColWidth='0'
      customPadding='var(--spacing-7)'
      showPagination
      pageSize={20}
    />
  );
};
